// extracted by mini-css-extract-plugin
export default {"PasswordResetEmailForm__submit":"yu_a bho_ql bho_tq"};